import { BASE_URL } from "../config/settings";
import httpRequest from "../utils/httpRequest";
import { objToParamsContinuation } from "../utils/func";

export const getUpcomingEvents = async (type, params) => {
  return await httpRequest(`${BASE_URL}/v2/Event/upcoming?type=${type}${objToParamsContinuation(params)}`);
};

export const registerEvents = async (eventId) => {
  return await httpRequest(
    `${BASE_URL}/v2/Event/${eventId}/register`,
    "post",
  );
};

